// 导入公共入口文件 (必须)
import main from '@/main.js';

//初始化公共vuex方法
import initGlobalData from '@/initGlobalData';

//神策,不用可注释
import Vue from 'vue';
import Sensors from '@/components/js/sensors'; //神策

// 设置 UI mode
Vue.prototype.$uiTheme = 'hll';

// 字体
import './assets/fonts/font.css';

//工具类
import { getUrlParam } from '@/utils';
import { parseUserTypeForLogin, isEnterprise } from './utils';

// 注册 theme 切换组件
import ThemeCompSwitch from '@/components/templates/common/ThemeCompSwitch';
Vue.component('theme-comp-switch', ThemeCompSwitch);

import request from '@/axios/request';

import rootStore from '@/store';

import { loadTemplate } from './template';

import { hackXlCarStikcerTpl } from './page-helper';

function resolveParams() {
  const bl = getUrlParam('bl');
  const u = getUrlParam('u');
  const userType = parseUserTypeForLogin(u, bl);
  const code = getUrlParam('code');
  const tpl = getUrlParam('tpl');
  const mode = getUrlParam('m') || '1'; // t=1单个模板 t=2组合模板
  if (!u || !code || !tpl || !bl) {
    Vue.prototype.$hll.toast('活动参数错误');
    throw new Error('param 参数错误');
  }
  return [userType, code, tpl, mode, bl];
  // return ['user', 'i2Ivm6Jz', 'lottery', '1']; // luckyegg lightbox luckycard i2Ivm6Jz
}

const [userType, code, tpl, mode, bl] = resolveParams();

import getCompanyToken from '@/utils/getCompanyToken';

// 小拉存量车贴活动模板 需要进行灰度然后跳转至新版本车外贴
hackXlCarStikcerTpl(code);

function resolveToken() {
  return new Promise(resolve => {
    if (isEnterprise(bl)) {
      // 企业 app 需要异步取 token
      return getCompanyToken().then(resolve);
    }
    const token = getUrlParam('token') || getUrlParam('_token');
    resolve(token);
  });
}

//神策埋点
const sensorUsertype = bl === '8' ? 'xluser' : userType;
Vue.use(Sensors, sensorUsertype, rootStore);

//mock 使用mock时页面所有请求将失效,全部由mock进行代理
//仅作为开发时使用,联调时请注释或删除
// import mock from './mock';
// process.env.NODE_ENV === 'production' || mock(tpl, mode); //该注释还是注释,避免忘记注释把mock部署到服务器

resolveToken().then(token => {
  //初始化,设置活动的初始信息
  let init = initGlobalData({
    env: userType,
    actName: code,
    businessLine: bl, // bl: 业务线 默认值4 ， 2：搬家， 3：货运大货车， 4：货运小B， 5：零担物流， 6：企业  8: 小拉
    accountType:
      bl === '8' || location.host.indexOf('xiaolachuxing.com') > -1
        ? 'xl'
        : null, // 账号类型 xl|null
    appToken: token,
    uuid: getUrlParam('uuid'),
    ref: getUrlParam('ref'),
    version:
      getUrlParam('version') ||
      getUrlParam('revision') ||
      getUrlParam('app_ver')
  });
  loadTemplate(userType, code, tpl, Number(mode)).then(
    ({ store, router, i18n }) => {
      // 请求方法
      Vue.use(request, router, rootStore);
      // 传递一个要展示的页面组件给公共入口函数 (必须),第三个可选参数为store
      main.init(router, init, store, i18n);
    }
  );
});
